import React from 'react';
import { InputMask } from "primereact/inputmask";
import Utils from './Utils';

const CpfCnpjDisplay = ({ cpf, cnpj, disabled = true, className = "" }) => {
    // Determina qual valor usar e qual máscara aplicar
    const getValue = () => {
        if (cpf && cpf.trim()) {
            return cpf
            //return Utils.formatCpf(cpf);
        }
        if (cnpj && cnpj.trim()) {
            return cnpj
            //return Utils.formatCnpj(cnpj);
        }
        return '';
    };

    const getMask = () => {
        if (cpf && cpf.trim()) {
            return "999.999.999-99";
        }
        if (cnpj && cnpj.trim()) {
            return "99.999.999/9999-99";
        }
        return "999.999.999-99"; // Default para CPF
    };

    const getLabel = () => {
        if (cpf && cpf.trim()) {
            return "CPF";
        }
        if (cnpj && cnpj.trim()) {
            return "CNPJ";
        }
        return "CPF/CNPJ";
    };

    const getId = () => {
        if (cpf && cpf.trim()) {
            return "usuario.profile.cpf";
        }
        if (cnpj && cnpj.trim()) {
            return "usuario.profile.cnpj";
        }
    };

    return (
        <span className="p-float-label">
            <InputMask
                value={getValue()}
                mask={getMask()}
                disabled={disabled}
                className={className}
                id={getId()}
                type="text"
            />
            <label htmlFor={getId()}>{getLabel()}</label>
        </span>
    );
};

export default CpfCnpjDisplay;